module.exports = __webpack_public_path__ + "static/media/generative-ai-classroom.692af48f.png";